import React, { useEffect } from "react";
import "../privacy.css";
import ScrollTop from "../components/ScrollTop";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="containers">
        <h1>Privacy Policy</h1>
        <h5 className="mt-4">INTRODUCTION</h5>
        <p>
          This Privacy Policy outlines how we process Personal Data collected
          from visitors and users of our website at{" "}
          <a href="www.halalmeats.store">www.halalmeats.store</a>. It also
          explains our commitment to protecting your privacy and your rights
          regarding the use of your Personal Data.
        </p>

        <h5 className="mt-4">WHO IS THE DATA CONTROLLER?</h5>
        <p>
          A “data controller” is an entity that determines the purposes and
          means of processing personal data. Meatwala High Wycombe Ltd, a
          company registered in England and Wales (Company Number: 15260965),
          with its registered office at 6 Shelburne Court, High Wycombe,
          England, HP12 3NH (“Meatwala,” “we,” “us,” “our”), is the data
          controller for the purposes of this policy.
        </p>
        <p>
          For any questions regarding data protection, you can contact us at{" "}
          <a href="contact@meatwala.co.uk">contact@meatwala.co.uk</a>.
        </p>

        <h5 className="mt-4">WHAT IS PERSONAL DATA?</h5>
        <p>
          Personal Data refers to any information relating to an identified or
          identifiable living individual. This includes information that, when
          combined, can identify a specific person.
        </p>

        <h5 className="mt-4">LEGAL BASES FOR PROCESSING PERSONAL DATA?</h5>
        <p>
          Under the <strong>UK Data Protection Act (DPA)</strong> and{" "}
          <strong>UK GDPR</strong>, we process your Personal Data based on at
          least one of the following legal grounds:
          <ul>
            <li>
              <strong>Consent</strong>: You have given us permission to process
              your data.
            </li>
            <li>
              <strong>Contractual necessity</strong>: Processing is necessary to
              fulfill a contract with you.
            </li>
            <li>
              <strong>Legal obligation</strong>: We are required by law to
              process the data.
            </li>
            <li>
              <strong>Legitimate interests</strong>: Processing is necessary for
              our business interests and does not override your rights.
            </li>
          </ul>
        </p>

        <h5 className="mt-4">PERSONAL DATA WE COLLECT</h5>
        <p>We may collect and process the following types of Personal Data:</p>

        <p>
          <strong>a) Information You Provide:</strong>
          <ul>
            <li>Name, address, email, and phone number.</li>
            <li>
              Account registration details (username, password, IP address,
              date/time of registration).
            </li>
            <li>
              Order details and payment information (processed via Stripe; we do
              not store payment data).
            </li>
            <li>
              Store registration information (business name, company details,
              contact details).
            </li>
            <li>
              Content you upload for store listings (images, text, location,
              business info).
            </li>
          </ul>
        </p>

        <p>
          <strong>b) Information Collected Automatically:</strong>
          <ul>
            <li>
              IP address, browser type, device information, pages visited.
            </li>
            <li>Cookie data (see our Cookie Policy for details).</li>
            <li>Server logs for security and analytics purposes.</li>
          </ul>
        </p>

        <p>
          {" "}
          <strong>c) Service Data (for store admin panel users): </strong>
          If you operate a store through our platform, you act as the data
          controller, and we act as the data processor. You are responsible for
          obtaining necessary consents from customers whose data you collect
          through our services.
        </p>

        <h5 className="mt-4">HOW WE USE YOUR PERSONAL DATA?</h5>
        <p>We process Personal Data to:</p>
        <p>
          <ul>
            <li>Provide and manage our website, app, and ordering platform.</li>
            <li>Process payments and fulfill orders.</li>
            <li>
              Communicate with customers regarding orders, issues, and
              promotions.
            </li>
            <li>Improve our services and user experience.</li>
            <li>Detect and prevent fraud or security threats.</li>
            <li>Comply with legal obligations.</li>
          </ul>
        </p>

        <h5 className="mt-4">SHARING YOUR PERSONAL DATA?</h5>
        <p>We may share your data with:</p>
        <p>
          <ul>
            <li>Payment processors (Stripe) to facilitate transactions.</li>
            <li>Delivery service providers to complete your order.</li>
            <li>IT and system administration service providers.</li>
            <li>Marketing platforms (only with your consent).</li>
            <li>Government authorities where required by law.</li>
          </ul>
        </p>
        <p>
          We do <strong>not</strong> sell your Personal Data to third parties.
        </p>

        <h5 className="mt-4">International Data Transfers</h5>
        <p>
          Where data is transferred outside the UK, we ensure appropriate legal
          safeguards, such as Standard Contractual Clauses (SCCs), are in place.
        </p>

        <h5 className="mt-4">Marketing and Advertising</h5>
        <p>
          <ul>
            <li>
              If you have given consent, we may send promotional emails or SMS
              messages.
            </li>
            <li>
              You can opt-out at any time by clicking unsubscribe in emails or
              contacting us.
            </li>
            <li>
              Third-party tools may collect information on browsing behavior to
              serve personalized ads.
            </li>
          </ul>
        </p>

        <h5 className="mt-4">HOW LONG DO WE KEEP YOUR DATA?</h5>
        <p>
          We retain Personal Data only as long as necessary for its intended
          purpose:
        </p>
        <p>
          <ul>
            <li>
              <strong>Order data:</strong> Retained for at least 6 years for tax
              and legal compliance.
            </li>
            <li>
              <strong>Marketing data:</strong> Retained until you withdraw
              consent.
            </li>
            <li>
              {" "}
              <strong>Account data:</strong> Deleted upon request unless
              required for legal reasons.
            </li>
          </ul>
        </p>

        <h5 className="mt-4">YOUR RIGHTS </h5>
        <p>You have the following rights under UK GDPR:</p>
        <p>
          <ul>
            <li>
              <strong>Right to access:</strong> Request a copy of your data.
            </li>
            <li>
              <strong>Right to rectification:</strong> Request corrections to
              inaccurate data.
            </li>
            <li>
              {" "}
              <strong>Right to erasure:</strong> Request deletion of your data.
            </li>
            <li>
              {" "}
              <strong>Right to restriction:</strong> Limit processing of your
              data.
            </li>
            <li>
              {" "}
              <strong>Right to data portability:</strong> Request transfer of
              data to another service.
            </li>
            <li>
              {" "}
              <strong>Right to object:</strong> Object to certain types of data
              processing.
            </li>
          </ul>
        </p>

        <p>
          To exercise any of these rights, contact us at{" "}
          <a href="contact@meatwala.co.uk">contact@meatwala.co.uk</a>.
        </p>

        <h5 className="mt-4">DATA SECURITY</h5>
        <p>
          We implement appropriate security measures to prevent unauthorized
          access, loss, or misuse of your Personal Data. However, no system is
          100% secure, so users should also take care to protect their own
          credentials.{" "}
        </p>

        <h5 className="mt-4">Cookies and Tracking Technologies</h5>
        <p>
          We use cookies and similar technologies for website functionality and
          analytics. You can manage your cookie preferences in our Cookie
          Consent Tool. See our Cookie Policy for details.
        </p>

        <h5 className="mt-4">THIRD-PARTY SERVICES</h5>
        <p>
          Our website may contain links to third-party services, such as Google
          Analytics and payment processors. We are not responsible for their
          privacy practices. You should review their policies before providing
          Personal Data.
        </p>

        <h5 className="mt-4">CHANGES TO THIS POLICY </h5>
        <p>
          This policy was last updated on <strong>[3rd March 2025]</strong>. Any
          future changes will be posted here, and prior versions will no longer
          be valid.
        </p>

        <h5 className="mt-4">COMPLAINTS AND CONTACT INFORMATION</h5>
        <p>
          For any concerns about this policy or your Personal Data, contact us
          at <a href="contact@meatwala.co.uk">contact@meatwala.co.uk</a>.
        </p>

        <p>
          By using our services, you acknowledge and accept this Privacy Policy.
        </p>
      </div>
      <ScrollTop />
    </>
  );
};

export default PrivacyPolicy;
